import { Box, CircularProgress, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useAccount } from 'wagmi';

import { EditNodeSaleForm } from 'src/components/NodeSaleForm/EditNodeSaleForm';
import { DeploymentProvider } from 'src/provider/DeploymentProvider';
import { ThemeCustomizationProvider } from 'src/provider/ThemeCustomizationProvider';
import { useGetProjectDetailQuery } from 'src/store/services/project.service';

const EditNodeSale = () => {
  const { id } = useParams();
  const { address } = useAccount();
  const { data, isLoading } = useGetProjectDetailQuery(
    { id, address },
    {
      skip: !id || !address,
    },
  );

  return (
    <Box width={'100%'} height={'100%'} display={'flex'} justifyContent={'center'} minHeight={'100dvh'}>
      <Box
        sx={{
          marginTop: '40px',
          maxWidth: '728px',
          width: '100%',
        }}>
        <Typography
          textAlign={'center'}
          color={'white'}
          fontWeight={700}
          fontSize={'32px'}
          variant='h5'
          paddingBottom={3}>
          EDIT SALE PROGRAM
        </Typography>
        {isLoading ? (
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
            }}>
            <CircularProgress />
          </Box>
        ) : null}
        <DeploymentProvider initialHasDeployed={false}>
          <ThemeCustomizationProvider>
            <EditNodeSaleForm defaultValues={data} />
          </ThemeCustomizationProvider>
        </DeploymentProvider>
      </Box>
    </Box>
  );
};

export default EditNodeSale;
